import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Alert,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";

function CredentialField({ label, value }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  return (
    <TextField
      fullWidth
      label={label}
      value={value}
      margin="dense"
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleCopy} edge="end" size="small">
              {copied ? (
                <CheckIcon fontSize="small" sx={{ color: "#3bc97b" }} />
              ) : (
                <ContentCopyIcon fontSize="small" />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#f8fafc",
        },
      }}
    />
  );
}

function PayrollCredentialsModal({ open, onClose, username, password, pin, modalText }) {
  const handleCopyAll = async () => {
    const text = `Username: ${username}\nPassword: ${password}\nPIN: ${pin}`;
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>
        {modalText}
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Save these credentials now. For security reasons, they will not be
          shown again.
        </Alert>

        <CredentialField label="Login Username" value={username} />
        <CredentialField label="Password" value={password} />
        <CredentialField label="PIN" value={pin} />

        <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
          Note: The actual email address provided for this user is used only
          for notifications (password reset, PIN reset, OTP), not for login.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleCopyAll} variant="outlined">
          Copy All
        </Button>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{ backgroundColor: "#3bc97b", "&:hover": { backgroundColor: "#2ea866" } }}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PayrollCredentialsModal;